module.exports = __webpack_public_path__ + "media/images/mobile/home/banner9 (1)-fe4c76531dafda13f2a0928a82251856.jpg";